import React from "react";
import { useSelector } from "react-redux";

import { ReactComponent as LogoIcon } from "../../../images/logo.svg";
import { getHoursMinutesTime } from "../../../constant/helper";
import AvatarPreview from "../../profile/components/AvatarPreview";
import MessageDateCategories from "./MessageDateCategories";

const MessageTicket = ({ data, messagesList, index, currentlyItem }) => {
  const { content, createdDateMilli: time, subscriberId, fullName } = data;
  //data.id, data.ticketId
  const { profile } = useSelector((state) => state);
  let support = true;
  if (profile && profile.data && profile.data.id) {
    if (subscriberId === profile.data.id) {
      support = false;
    }
  }

  return (
    <React.Fragment>
      <MessageDateCategories
        className={{
          textAlign: "center",
          color: "#656567",
          fontWeight: "400",
          fontSize: "14px",
          marginBottom: "1rem",
        }}
        messagesList={messagesList}
        index={index}
        currentlyItem={currentlyItem}
      />
      <div
        className={`msg ${support ? "msg-bot-holder" : "msg-client-holder"}`}
        style={{ marginRight: support && "auto" }}
      >
        <div className="msg-wrapper">
          {content && <div className="msg-text">{content}</div>}
          <div className={"msg-avatar-bg"}>
            <div className={"msg-avatar-holder"}>
              <div className={"msg-avatar"}>
                <AvatarPreview
                  isSvg={false}
                  src={
                    support
                      ? 7
                      : profile.data.extraInfo?.avatarImageUrl || "LAWONE"
                  }
                />
              </div>
            </div>
          </div>
          {support && (
            <div className={"support-name"} style={{ color: "#ccc" }}>
              {" "}
              {fullName}{" "}
            </div>
          )}
          <div className={"msg-time"}>{time && getHoursMinutesTime(time)}</div>
          <div className="msg-bg-holder">
            <span className={"msg-logo-bg"}>
              <LogoIcon />
            </span>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MessageTicket;
